import { Provider } from '@angular/core';

import { SearchUseCasesImpl } from '@app/domain/use-cases/search/search.use-cases';
import { SEARCH_USE_CASES } from '@app/domain/use-cases/search/search.use-cases.contract';

export const searchUseCasesProvider: Provider = {
  provide: SEARCH_USE_CASES,
  useClass: SearchUseCasesImpl
};
